
import FlashsalePage from '~/pages/_lang/flash-sale-list/index.vue'
export default FlashsalePage
